import { useState } from "react";
import { Outlet } from "react-router";

import { FormCreateResumeProvider } from "../../../dashboard/_components/form-create";
import { CreationFormResume } from "../../../dashboard/resumes/_layouts/creation-form-resume";
import { useAccountOverview } from "../../hooks/use-account-overview";
import { DesktopSidebar } from "../navigation/desktop-sidebar";
import { MobileHeader } from "../navigation/mobile-header";
import { MobileNavigation } from "../navigation/mobile-navigation";
import { UserSpaceTopbar } from "./user-space-topbar";

export const UserSpaceLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { overview, loading, refreshing, refetch } = useAccountOverview();

  const toggleDesktopSidebar = () => {
    setSidebarCollapsed((currentValue) => !currentValue);
  };

  const openMobileMenu = () => {
    setMobileMenuOpen(true);
  };

  return (
    <FormCreateResumeProvider>
      <div className="flex h-dvh overflow-hidden bg-slate-50 text-slate-950">
        <DesktopSidebar
          collapsed={sidebarCollapsed}
          onCollapse={toggleDesktopSidebar}
          currentPlanName={overview.currentPlan.name}
          currentPlanCode={overview.currentPlan.code}
        />

        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <MobileHeader onMenuOpen={openMobileMenu} />

          <UserSpaceTopbar
            planName={overview.currentPlan.name}
            downloads={overview.downloadCredits}
            downloadsExpiring={overview.downloadCreditsExpiring}
            aiCredits={overview.aiCredits}
            rewards={overview.totalRewardsFcfa}
            fidelity={overview.loyaltyPoints}
            loading={loading}
            refreshing={refreshing}
            onRefresh={refetch}
          />

          <main
            id="main-content"
            className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden"
          >
            <Outlet />
          </main>
        </div>

        <MobileNavigation menuOpen={mobileMenuOpen} onMenuOpenChange={setMobileMenuOpen} />

        <CreationFormResume />
      </div>
    </FormCreateResumeProvider>
  );
};
